import React from 'react'
import {Link, useNavigate} from "react-router-dom";
import Sidebar from "../../../../components/Sidebar";
import PageHeader from "../../../../components/PageHeader";
import {toast} from "react-toastify";
import moment from "moment";
import DatePicker, {registerLocale} from "react-datepicker";
import {getSchoolId, getSchoolYear} from "../../../../utils/authority";
import GradeManager from "../../../../components/Grade";
import ClassRoomController from "../../../../services/data-declaration/class-room-controller";
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vi from "date-fns/locale/vi";
import PublicSecureAuthorization
    from "../../../../services/system/secure-authorization/secure-authorization-controller";
import NotiController from "../../../../services/system/noti/noti-controller";
import FilesApi from "../../../../services/resource/files-api";
import Dropzone from "react-dropzone";
import CLBController from "../../../../services/system/clb/clb-controller";
import AutoSearchPeople from "../../../../components/auto-search-people";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import StudentController from "../../../../services/system/student/student-controller";
registerLocale("vi", vi);
function withRouter(Component) {
    return (props) => <Component {...props} navigate={useNavigate()} />;
}
function uploadAdapter(loader) {
    return {
        upload: () => {
            return new Promise((resolve, reject) => {
                FilesApi.uploadFileCkeditor( loader, res => {
                    if (res.success) {
                        resolve({
                            default: res.data.url
                        });
                    }else {
                        reject(res.error);
                    }
                })
            })
        }
    }
}
function uploadPlugin(editor) {
    editor.plugins.get("FileRepository").createUploadAdapter = (loader) => {
        return uploadAdapter(loader);
    };
}
class CreateNotiManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            image: "",
            icon: "",
            imgFile: "",
            imgFileIcon: "",
            principalId: "",
            principalName: "",
            principalUserName: "",
            studentId: "",
            groupUser: "",
            listStudent: [],
            dateActive: new Date(),
            type: "SYSTEM",
            notifyObjType: "ALL",
            gradeId: "",
            gradeStr: "",
            shortDescription: "",
            studentsId: [],
            officersId: [],
            listCLB: [],
            title: "",
            groupId: 0,
            yearId: parseInt(getSchoolYear()),
            state: "WAIT_PUBLISH",
            content: "",
            listGroupUser: [],
            classRoomId: -1,
            clbId: -1,
            listClassRoom: [],
            files: [],
            filesIcon: [],
        };
    }

    componentWillMount() {
        this.getAllClass()
        this.getListGroupUser()
        this.getListCLB()
        this.getListStudent()
    }
    getListStudent() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            classRoomId: this.state.classRoomId,
            grade: this.state.gradeId,
            fullName: this.state.studentName,
            code: "",
            ethnic: "",
            gender: "",
            pageNumber:0,
            pageSize: 100,
            sort: "created_at desc",
            studentState: "",
        };
        StudentController.search(payload, res => {
            this.setState({
                listStudent: res.data.content,
            });
        })
    }
    getListCLB() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            name: "",
            state: "ACTIVE",
            teachId:  -1,
            pageNumber:0,
            pageSize: 10000,
            sort: "created_at desc",
        };
        CLBController.list(payload, res => {
            this.setState({
                listCLB: res.data.content,
            });
        })
    }
    saveContent(newContent) {
        this.setState({
            content: newContent,
        });
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    getAllClass = () => {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.list(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    };
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderCLB = () => {
        return this.state.listCLB.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    renderStatus() {
        let listStatus = [
            {
                "id": "WAIT_PUBLISH",
                "name": "Chờ phát hành"
            },
            {
                "id": "PUBLISH",
                "name": "Hoạt động"
            },
            {
                "id": "LOCKED",
                "name": "Đã khóa"
            },
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    onCreate = () => {
        let {title} = this.state;
        if (title == "" || title.length < 5){
            toast.error("Tiêu đề thông báo phải lớn hơn 5 ký tự");
        }else if(this.state.content == ""){
            toast.error("Vui lòng nhập nội dung thông báo");
        }else {
            let payload = {
                "content": this.state.content,
                "dateActive": moment(this.state.dateActive).format("yyyy-MM-DD hh:mm:ss"),
                "image": this.state.image == null?"":  this.state.image,
                "icon": this.state.icon == null?"":  this.state.icon,
                "shortDescription": this.state.shortDescription,
                "state": this.state.state,
                "type": this.state.type,
                "title": this.state.title,
                "schoolFilter": {
                    "clbId": parseInt(this.state.clbId),
                    "classRoomId": parseInt(this.state.classRoomId),
                    "gradeStr": this.state.gradeId,
                    "groupUser": this.state.groupUser,
                    "notifyObjType": this.state.notifyObjType,
                    "yearId": parseInt(getSchoolYear()),
                    "schoolId": parseInt(getSchoolYear())
                },
                "studentsId":  this.state.studentId != null? this.state.studentId != ""? [this.state.studentId]: [] : [],
                "officersId": this.state.principalId != null? this.state.principalId != ""? [this.state.principalId]: [] : []
            }
            NotiController.create(payload, res => {
                if (res.success){
                    this.props.navigate('/ad-sas-school/quan-ly-thong-bao');
                    toast.success("Tạo thông báo thành công!")
                } else {
                    toast.error("Đã xảy ra lỗi! " + res.message)
                }
            })
        }
    }
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            if (gradeId === "")
                this.getAllClass()
            else {
                this.getListClass()
            }
        });
    }
    getListClass = () => {
        let payload = {
            name: "",
            grade: this.state.gradeId,
            yearId: parseInt(getSchoolYear()),
            pageNumber: 0,
            pageSize: 1000,
            "sort": "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                listClassRoom: res.data.content
            });
        })
    };
    onFileChange = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    url: res.data.url,
                }, () => {
                    toast.success('Upload thành công!')
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    onUpImage = () => {
        let payload = {
            file: this.state.files,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    image: res.data.url,
                }, () => {
                    toast.success('Tải ảnh thành công!')
                    this.showImage();
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    showImage(){
        if (this.state.image.length > 0){
            FilesApi.showFile(this.state.image, res=>{
                this.setState({
                    imgFile: res
                })
            })
        }
    }
    onUpIcon = () => {
        let payload = {
            file: this.state.filesIcon,
        }
        FilesApi.uploadFile(payload, res => {
            if (res.success) {
                this.setState({
                    icon: res.data.url,
                }, () => {
                    toast.success('Tải ảnh thành công!')
                    this.showIcon();
                })
            }
        }).catch(error => console.log("upload error>>>", error))
    };
    showIcon(){
        if (this.state.icon.length > 0){
            FilesApi.showFile(this.state.icon, res=>{
                this.setState({
                    imgFileIcon: res
                })
            })
        }
    }
    render() {
        let {gradeId} = this.state
        const files = this.state.files.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        const filesIcon = this.state.filesIcon.map(file => (
            <li key={file.name}>
                {file.name}-{file.size} bytes
            </li>
        ));
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="noti-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            <div className="card col-12">
                                <div className='pt-3 mb-2'>
                                    <PageHeader routerEnable={true} title="Thêm mới thông báo"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <h2 className='text-center mb-4'>THÊM MỚI THÔNG BÁO</h2>
                                        <div className="row">
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 col-xs-12 label-item pl-0">Tiêu đề thông báo<span  style={{color: "red",}}>*</span></label>
                                                <input
                                                    placeholder="Nhập tiêu đề thông báo"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.title}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            title: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 col-xs-12 label-item pl-0">Mô tả ngắn</label>
                                                <input
                                                    placeholder="Nhập mô tả nội dung"
                                                    maxLength={255} type="text"
                                                    className="form-control shadow-none"
                                                    value={this.state.shortDescription}
                                                    onChange={(event) => {
                                                        this.setState({
                                                            shortDescription: event.target.value
                                                        })
                                                    }}
                                                />
                                            </div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 label-item pl-0">Ảnh thông báo</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({files: acceptedFiles}, () =>{
                                                                  this.onUpImage()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <img width="200px" key={this.state.imgFile} src={this.state.imgFile} />
                                                                <input {...getInputProps()} />
                                                                {files.length > 0 ? <div className="align-center">
                                                                    <ul>{files}</ul>
                                                                </div> : <p>Chọn tập tin để upload</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-md-12 col-xs-12 d-flex mb-2">
                                                <label className="col-md-2 label-item pl-0">Icon</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({filesIcon: acceptedFiles}, () =>{
                                                                  this.onUpIcon()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <img width="200px" key={this.state.imgFileIcon} src={this.state.imgFileIcon} />
                                                                <input {...getInputProps()} />
                                                                {filesIcon.length > 0 ? <div className="align-center">
                                                                    <ul>{filesIcon}</ul>
                                                                </div> : <p>Chọn tập tin để upload</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-md-12 col-xs-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Nội dung thông báo<span  style={{color: "red",}}>*</span></label>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                {/*https://www.techgalery.com/2021/05/how-to-use-react-ckeditor-upload-file.html*/}
                                                <CKEditor
                                                    config={{
                                                        extraPlugins: [uploadPlugin]
                                                    }}
                                                    editor={ ClassicEditor }
                                                    data=""
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        // console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={ ( event, editor ) => {
                                                        const data = editor.getData();
                                                        this.saveContent(data)
                                                        // console.log( { event, editor, data } );
                                                    } }
                                                />
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-2">File đính kèm</label>
                                                <Dropzone accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, text/csv, video/mp4, audio/mpeg, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation, text/plain, application/vnd.ms-excel
, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/zip, application/x-7z-compressed"
                                                          onDrop={acceptedFiles => {
                                                              this.setState({files: acceptedFiles}, () =>{
                                                                  this.onFileChange()
                                                              })
                                                          }}
                                                          multiple={false}>
                                                    {({getRootProps, getInputProps}) => (
                                                        <section className="container-upload col-md-10">
                                                            <div {...getRootProps({className: 'dropzone'})}>
                                                                <input {...getInputProps()} />
                                                                {files.length > 0 ? <div className="align-center">
                                                                    <ul>{files}</ul>
                                                                </div> : <p>Chọn tập tin để upload</p>}
                                                            </div>
                                                        </section>
                                                    )}
                                                </Dropzone>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mt-2">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.state}
                                                    onChange={(e) => {
                                                        this.state.state = e.target.value;
                                                        this.setState({
                                                            state: e.target.value
                                                        })
                                                    }}
                                                >
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mt-2">
                                                <label className="label-item col-md-4">Loại thông báo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.type}
                                                    onChange={(e) => {
                                                        this.setState({
                                                            type: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="SYSTEM">Hệ thống</option>
                                                    <option value="SCHOOL">BGH Nhà trường</option>
                                                    <option value="HOC_PHI">Học phí</option>
                                                    <option value="DIEM_DANH">Điểm danh</option>
                                                    <option value="HOC_TAP">Học tập</option>
                                                </select>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mt-2">
                                                <label className="col-md-4 label-item pl-0">Ngày kích hoạt</label>
                                                <DatePicker
                                                    locale="vi"
                                                    className="w-auto2 react-datepicker-wrapper2 react-datepicker__input-container form-control shadow-none"
                                                    placeholderText="Ngày kích hoạt"
                                                    selected={this.state.dateActive === null ? "" : new Date(this.state.dateActive)}
                                                    minDate={new Date()}
                                                    dateFormat="dd-MM-yyyy"
                                                    isClearable={this.state.dateActive === null ? false : true}
                                                    selectsStart
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    onChange={
                                                        (date) => {
                                                            this.setState({
                                                                dateActive: date === null ? null : moment(date).format("YYYY-MM-DD"),
                                                            })
                                                        }
                                                    }
                                                    dateActive={new Date()}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-12 d-flex mb-2 bg-top-title mt-2">
                                            Chọn đối tượng nhận thông báo
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Đối tượng nhận thông báo</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.notifyObjType}
                                                    onChange={(e) => {
                                                        this.state.notifyObjType = e.target.value;
                                                        this.setState({
                                                            notifyObjType: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="ALL">Tất cả</option>
                                                    <option value="STUDENT">Cán bộ trường</option>
                                                    <option value="OFFICER">Phụ huynh</option>
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2"></div>
                                            {/*<div className="col-md-6 col-xs-12 d-flex mb-2">*/}
                                            {/*    <label className="col-4 label-item pl-0">Nhóm người dùng</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.groupUser}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            this.state.groupUser = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                groupUser: e.target.value,*/}
                                            {/*                inEditing: true*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option value="-1">Tất cả</option>*/}
                                            {/*        {this.state.listGroupUser?.map((item, index) => <option value={item.role}>{item.role}</option>)}*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                        </div>
                                        <div className="row">
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        this.state.classRoomId = e.target.value;
                                                        this.setState({
                                                            classRoomId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Lớp CLB</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.clbId}
                                                    onChange={(e) => {
                                                        this.state.clbId = e.target.value;
                                                        this.setState({
                                                            clbId: e.target.value,
                                                            inEditing: true
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn CLB</option>
                                                    {this.renderCLB()}
                                                </select>
                                            </div>

                                            <div className="col-md-6 col-xs-12 d-flex mb-2"></div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn học sinh</label>
                                                <Autocomplete
                                                    size="small"
                                                    options={this.state.listStudent}
                                                    getOptionLabel={option => option.fullName?option.fullName:""}
                                                    style={{width: '100%'}}
                                                    inputValue={this.state.studentName}
                                                    renderInput={params => {
                                                        return <TextField
                                                            placeholder='Nhập tên học sinh'
                                                            {...params}
                                                            InputLabelProps={{
                                                                shrink: true,
                                                                style: {
                                                                    fontSize: 17,
                                                                    backgroundColor: "#FFF",
                                                                    paddingRight: 10,
                                                                    paddingLeft: 10,
                                                                    color: '#2e495c',
                                                                    fontWeight: 500,
                                                                    fontFamily: 'Montserrat'
                                                                }
                                                            }}
                                                            label=""
                                                            variant="outlined"
                                                            fullWidth
                                                        />
                                                    }}
                                                    onInputChange={(event, val) => {
                                                        if (event !== null){
                                                            this.setState({
                                                                studentName: val
                                                            })
                                                            if (val === ""){
                                                                this.state.studentId = -1;
                                                            }
                                                        }
                                                    }}
                                                    onChange={(e, val) => {
                                                        if (val?.id != undefined){
                                                            this.setState({
                                                                studentId: val?.id,
                                                                studentName: val?.fullName,
                                                            })
                                                        }else {
                                                            this.setState({
                                                                studentId: -1,
                                                                studentName: "",
                                                            })
                                                        }
                                                        // this.getListPeopleInCharge()
                                                    }}

                                                />
                                            </div>
                                            <div className="col-md-6 col-xs-12 d-flex mb-2">
                                                <label className="col-4 label-item pl-0">Chọn cán bộ</label>
                                                <AutoSearchPeople
                                                    principalId={this.state.principalId}
                                                    principalName={this.state.principalName}
                                                    principalUsername={this.state.principalUsername}
                                                    onUpdateData={(principalId, principalUsername, principalName) => this.setState({principalId: principalId, principalName: principalName, principalUsername: principalUsername})}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="align-right col-12">
                                    <div className="d-flex justify-content-center align-center mt-3 mb-2">
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s background-btn type-button-fix btn btn-primary shadow-none"
                                            disabled={this.state.title == ""}
                                            onClick={()=> {
                                                this.onCreate()
                                            }}
                                        >
                                            Lưu
                                        </button>
                                        <button
                                            type="button"
                                            className="ml-4 border-1-s type-button-fix btn btn-light shadow-none"
                                        >
                                            <Link
                                                style={{color: '#000'}}
                                                to={{
                                                    pathname: "/ad-sas-school/quan-ly-thong-bao"
                                                }}
                                            >
                                                Hủy bỏ
                                            </Link>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default withRouter(CreateNotiManagement)
